export const validateDataTransfer = (
  dataTransfer: DataTransfer,
  allowedMimeTypes: string[]
): boolean => {
  if (!dataTransfer.items) {
    return false;
  }

  const items = Array.from(dataTransfer.items);

  return (
    items.length === 1 &&
    items[0].kind === 'file' &&
    allowedMimeTypes.includes(items[0].type)
  );
};

export const getFirstFileFromDataTransfer = (
  dataTransfer: DataTransfer
): File | null => {
  const items = Array.from(dataTransfer.items);
  return items[0]?.getAsFile();
};
